import React from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string';
import { useForm } from 'react-hook-form'
import { resetPassword } from '../../api/authorization.api';
import { showSuccess,showError } from '../../services/toastServices';
import { logout } from '../../services/authorizationService';

const ResetPasswordPage = () => {
  const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
  const [resetPasswordToken, setresetPasswordToken] = useState('')
  const navigate = useNavigate()


    useEffect(() => {
      const getKey = (()=>{
        let search = window.location.search;
        let params = queryString.parse(search)
        if(params.key) setresetPasswordToken(params.key)
      })
      logout()
      getKey()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetPasswordSuccess = ((response)=>{
    showSuccess('Clave cambiada exitosamente')   
    navigate('/login')
  })

  const resetPasswordError = ((error)=>{
    showError('Error al cambiar contraseña')
    if (!error.response) {
      // network error
      this.errorStatus = 'Error: Network Error';
    } else {
        this.errorStatus = error.response.data.message;
    }
  })

  const handleOk = handleSubmit(async data => {
    if(resetPasswordToken && data.password === data.repeatedPassword){
        const payload = {
            email: data.email,
            resetPasswordToken: resetPasswordToken,
            newPassword: data.password
        }     
        await resetPassword(payload, resetPasswordSuccess, resetPasswordError)
    }else{
        showError("Url link not valid.")
    }   
})


  return (
    <div className="mainContainer">
      <div className='mx-auto grid grid-cols-4 gap-x-2'>
        <div className='col-start-2 col-span-2'>
          <div className="flex justify-center py-3">
            <h1 className='font-bold'>Cambio de contraseña</h1>
          </div>
        </div>
        <form action="" className='col-start-2 col-span-2'>
          <input
              type="text"
              placeholder="Email"
              {...register("email", { required: true })}
              className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
          />
          {errors.email && <span>Campo requerido</span>}

          <input
              type="password"
              placeholder="Password"
              {...register("password", { required: true })}
              className=' bg-blue-100 p-3 rounded-lg w-full mb-3'
          />
          {errors.password && <span>Campo requerido</span>}

          <input
              type="password"
              placeholder="Repetir Password"
              {...register("repeatedPassword", { required: true })}
              className=' bg-blue-100 p-3 rounded-lg w-full mb-3'
          />
          {errors.repeatedPassword && <span>Campo requerido</span>}

        </form>
        <button className=' bg-blue-400 p-3 rounded-lg block w-full col-start-2 col-span-2 hover:bg-blue-500' onClick={handleOk}>Aceptar</button>            
      </div>
    </div>
  )
}

export default ResetPasswordPage